import React, { useState, Dispatch, SetStateAction } from 'react'
import VisibilityTrigger from 'components/VisibilityTrigger'
import ArtworkPolaroidList from '../components/ArtworkPolaroidList'
import RequestCommission from '../components/RequestCommission'
import styles from '../components/artistProfile.module.scss'
import Carousels from '../components/carousel'
import AboutArtist from '../components/aboutArtist'
import FeaturedCollections from '../components/FeaturedCollections'
import TestimonialCarousel from '../components/TestimonialCarousel'
import FeaturedArticles from '../components/FeaturedArticles'

type Props = {
  setFollowedUserArray: Dispatch<SetStateAction<ReadonlyArray<number>>>
  followedUserArray: ReadonlyArray<number>
}
const ArtistProfile = ({ followedUserArray, setFollowedUserArray }: Props) => {
  const [shouldLoadComponent, setShouldLoadComponent] = useState(false)
  return (
    <div className={styles.profileLayout}>
      <ArtworkPolaroidList />
      <AboutArtist
        followedUserArray={followedUserArray}
        setFollowedUserArray={setFollowedUserArray}
      />
      <FeaturedCollections />
      <TestimonialCarousel />
      <FeaturedArticles />
      <VisibilityTrigger setShouldLoadComponent={setShouldLoadComponent} />
      <RequestCommission />
      {/* Only show if artist has 5 artworks or less */}
      <Carousels shouldLoadComponent={shouldLoadComponent} />
    </div>
  )
}

export default ArtistProfile
